const TargetThemes = {
  Published: "published",
  Draft: "draft",
};

export default TargetThemes;
